import { mapActions } from 'vuex'

export const incrustado = {
  data () {
    return {
      loadedAll: false
    }
  },
  async created () {
    try {
      if (process.env.NODE_ENV === 'development') {
        await this.setVariablesSesion({
          codigoAgrupacion: 'desdemo',
          idubapi: '1002100101'
        })
      }
      let error = await this.initialize()
      this.loadedAll = error
    } catch (error) {
      this.$router.push({name: 'incrustado.mensajeError'})
    }
  },
  methods: {
    ...mapActions({
      setVariablesSesion: 'login/setVariablesSesion'
    }),
    async initialize () {
      // Aquí va la funcion de inicializar del componente en sí
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/incrustado.js